/* ICON WRAPPER — EVERY ICON INHERITS THE CURRENT TEXT COLOR */
const Icon = ({ size = 16, width = 2, children }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={width} strokeLinecap="round" strokeLinejoin="round">
        {children}
    </svg>
)

/* SUIT WRAPPER — A SUIT IS A FILLED SHAPE, NOT A STROKE */
const Suit = ({ size = 14, children }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" stroke="none">
        {children}
    </svg>
)


/* CLOSE ICON */
export const CloseIcon = ({ size }) => (
    <Icon size={size}>
        <path d="M18 6 6 18M6 6l12 12" />
    </Icon>
)

/* SEARCH ICON */
export const SearchIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <circle cx="10.8" cy="10.8" r="6.8" />
        <path d="M20.5 20.5 15.7 15.7" />
    </Icon>
)

/* EDIT ICON — THE BARCODE OF A CARD OPENS IN A MODAL */
export const EditIcon = ({ size = 15 }) => (
    <Icon size={size}>
        <path d="M4 20h4L20 8l-4-4L4 16Z" />
        <path d="M14.5 5.5 18.5 9.5" />
    </Icon>
)

/* INFO ICON — THE HINT OF A SECTION */
export const InfoIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 11v5M12 7.6v.6" />
    </Icon>
)

/* BARCODE ICON — THE CODE A SCANNER READS */
export const BarcodeIcon = ({ size = 14 }) => (
    <Icon size={size}>
        <path d="M4 5.5v13M8 5.5v13M12 5.5v13M16 5.5v13M20 5.5v13" />
    </Icon>
)

/* DECK ICON — THE DECK ITSELF */
export const DeckIcon = ({ size = 14 }) => (
    <Icon size={size}>
        <rect x="7.5" y="4" width="12" height="16" rx="3" />
        <path d="M4.5 7.5v9.8A2.7 2.7 0 0 0 7.2 20" />
    </Icon>
)

/* LAYERS ICON — HOW MANY SUITS THE VIEW HOLDS */
export const LayersIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M12 3 21 8l-9 5-9-5Z" />
        <path d="M3 13.5l9 5 9-5" />
    </Icon>
)

/* CHECK ICON — EVERY CARD OF THE DECK HAS A CODE */
export const CheckIcon = ({ size = 13 }) => (
    <Icon size={size} width={3}>
        <path d="M20 6 9 17l-5-5" />
    </Icon>
)

/* WARNING ICON — A CODE IS MISSING OR TWO CARDS SHARE ONE */
export const WarningIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7.5V13M12 16.4v.6" />
    </Icon>
)

/* CLOCK ICON — THE MOMENT A BARCODE CHANGED */
export const ClockIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="8.5" />
        <path d="M12 7.5V12l3.5 2" />
    </Icon>
)

/* HASH ICON — THE NUMBER OF A CARD */
export const HashIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M9.5 3.5 7.5 20.5M16.5 3.5l-2 17M4 8.5h16M3 15.5h16" />
    </Icon>
)

/* VALUE ICON — THE WEIGHT OF A CARD INSIDE A GAME */
export const ValueIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M4 19.5 9.5 4.5l5.5 15" />
        <path d="M5.8 14.5h7.4M18 4.5v15" />
    </Icon>
)


/* HEART SUIT */
export const HeartIcon = ({ size }) => (
    <Suit size={size}>
        <path d="M12 21.2c-.4 0-.8-.2-1.1-.5C7.2 17.2 3 13.6 3 9.4 3 6.3 5.3 4 8.2 4c1.6 0 3 .8 3.8 2 .8-1.2 2.2-2 3.8-2C18.7 4 21 6.3 21 9.4c0 4.2-4.2 7.8-7.9 11.3-.3.3-.7.5-1.1.5Z" />
    </Suit>
)

/* DIAMOND SUIT */
export const DiamondIcon = ({ size }) => (
    <Suit size={size}>
        <path d="M12 2.5 21 12l-9 9.5L3 12Z" />
    </Suit>
)

/* CLUB SUIT */
export const ClubIcon = ({ size }) => (
    <Suit size={size}>
        <circle cx="12" cy="7.6" r="4.1" />
        <circle cx="6.9" cy="14.2" r="4.1" />
        <circle cx="17.1" cy="14.2" r="4.1" />
        <path d="M10.4 21.5c1-1.6 1.4-3.4 1.4-6h.4c0 2.6.4 4.4 1.4 6Z" />
    </Suit>
)

/* SPADE SUIT */
export const SpadeIcon = ({ size }) => (
    <Suit size={size}>
        <path d="M12 2.5c-1.2 1.5-8.4 6.2-8.4 10.9 0 2.5 1.9 4.3 4.3 4.3 1.5 0 2.9-.7 3.8-1.9.9 1.2 2.3 1.9 3.8 1.9 2.4 0 4.3-1.8 4.3-4.3C19.8 8.7 13.2 4 12 2.5Z" />
        <path d="M10.4 21.5c1-1.5 1.4-3 1.4-5.1h.4c0 2.1.4 3.6 1.4 5.1Z" />
    </Suit>
)
